<div
  class="doc-thumbnail"
  [class.has-thumbnail]="hasThumbnail()"
  [style.width]="size()"
  [style.height]="size()"
>
  @if (hasThumbnail()) {
    <img
      class="doc-thumbnail-img"
      [src]="thumbnailUrl()"
      [alt]="fileName()"
      loading="lazy"
      (error)="onError()"
    />
  } @else {
    <umss-icon [name]="fallbackIcon()" [size]="iconSize()" />
  }
</div>
